import React, { useEffect, useState } from 'react';
import './style.scss';
import clsx from 'clsx';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const TableComponent = (props) => {
  const { heading, table, text, tableMobile } = props?.fields;
  const { hideDivider, zebraStripedStyle, Styles, noPadding } = props.params;
  const isSub = !!props.sub;
  const needHeading = !!heading?.value;
  const needText = !!text?.value;
  const needTable = !!table?.value;
  const desktopTableClass = tableMobile?.value ? 'd-md-block d-none' : null;
  const [wrapperRef, setWrapperRef] = useState(null);

  useEffect(() => {
    if (wrapperRef) {
      const tr = wrapperRef?.getElementsByTagName('tr');
      let columnsNumber = 4;
      if (tr?.length > 0) {
        columnsNumber = tr[0].childElementCount;
      }
      const tables = wrapperRef?.getElementsByTagName('table');
      if (tables?.length > 0) {
        const table = tables[0];
        table.style.minWidth = `${200 * columnsNumber}px`;
      }
    }
  }, [wrapperRef]);
  if (!props?.fields || !props.params) return <GenericPlaceholder componentName="TableComponent" />;
  return (
    (needTable || needTable || needText) && (
      <div
        className={clsx(
          'table-component',
          !isSub && !noPadding && 'content',
          'add-margins',
          Styles
        )}
      >
        {needHeading && (
          <h3 className="table-component-header">
            <Text field={heading} />
          </h3>
        )}
        {needText && <RichText field={text} className="table-component-desc" />}
        <RichText
          field={table}
          className={clsx(
            'table-component-table-wrapper',
            desktopTableClass,
            hideDivider === '1' && 'table-wrapper-no-separators',
            zebraStripedStyle === '1' && 'table-wrapper-striped'
          )}
          ref={(el) => setWrapperRef(el)}
        />
        {tableMobile && (
          <RichText
            field={tableMobile}
            className={clsx(
              'table-component-table-wrapper',
              'd-md-none',
              hideDivider === '1' && 'table-wrapper-no-separators',
              zebraStripedStyle === '1' && 'table-wrapper-striped'
            )}
            ref={(el) => setWrapperRef(el)}
          />
        )}
      </div>
    )
  );
};

export default TableComponent;
